import * as OBC from '@thatopen/components';
import * as WEBIFC from "web-ifc";
import { FragmentsGroup } from '@thatopen/fragments';
import { createPsetsRow } from '../createPsetsRow';
import { createQsetsRow } from '../createQsetsRow';
import { getAllUnits } from '../getModelUnit';
export default async function LoadPropertiesFully(model: FragmentsGroup, components: OBC.Components) {
    console.log('LoadPropertiesFully', model);

    const relations = components.get(OBC.IfcRelationsIndexer);
    await relations.process(model);
    // console.log('Relations:', relations);
    const propsRows: any[] = [];
    const allUnits = await getAllUnits(model);
    console.log('allUnits:', allUnits);
    const promises = model.items.map((item) => {
        const idsArray = Array.from(item.ids); // Convert Set to Array
        // console.log('idsArray:', idsArray);
        return Promise.all(idsArray.map(async (id) => {
            const relationsOfElement = relations.getEntityRelations(model, id, 'IsDefinedBy');
            if (relationsOfElement) {
                const psets: { [attribute: string]: any }[] = [];
                const qsets: { [attribute: string]: any }[] = [];

                for (const definition of relationsOfElement) {
                    const attrs = await model.getProperties(definition);
                    if (!attrs) continue;
                    if (attrs.type === WEBIFC.IFCPROPERTYSET) psets.push(attrs);
                    if (attrs.type === WEBIFC.IFCELEMENTQUANTITY) qsets.push(attrs);
                }

                let propsets = await createPsetsRow(model, psets, id, true, allUnits);
                if (propsets.length > 0) propsRows.push([...propsets]);
                let qsetsRow = await createQsetsRow(model, qsets, id);
                if (qsetsRow.length > 0) propsRows.push([...qsetsRow]);
            }
        }));
    });
    console.log('propsRows - awaiting:', propsRows);
    await Promise.all(promises);
    console.log('propsRows:', propsRows);
    return propsRows;
};